import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { SET_ROUTE } from 'estimate_list/reducers/initial'
import { scrollTo } from 'estimate_list/libs/util'


const Page = () => {
    const { lists, route } = useSelector(state => state.initial)
    const total = lists.itemList.total
    const { size, page } = route
    const pageLenth = 10

    const pageFullSize = Math.ceil(total / size)
    const activeSize = Math.ceil(page / pageLenth)
    let startPage = (activeSize * pageLenth) - (pageLenth - 1)
    if (startPage <= 1) startPage = 1
    let endPage = activeSize * pageLenth
    if (pageFullSize <= endPage) endPage = pageFullSize

    const dispatch = useDispatch()

    const pageSizeArr = () => {
        let data = []
        for (let p = startPage; p <= endPage; p++) {
            data.push(p)
        }
        return data
    }

    const onClickPage = p => () => {
        scrollTo('#layout_list_group', -71, 'auto')
        dispatch({
            type: SET_ROUTE,
            data: { page: String(p) }
        })
    }

    const onClickNext = () => {
        scrollTo('#layout_list_group', -71, 'auto')
        dispatch({
            type: SET_ROUTE,
            data: { page: String(startPage + pageLenth) }
        })
    }

    const onClickPrev = () => {
        scrollTo('#layout_list_group', -71, 'auto')
        dispatch({
            type: SET_ROUTE,
            data: { page: String(startPage - 1) }
        })
    }

    const onClickStart = () => {
        scrollTo('#layout_list_group', -71, 'auto')
        dispatch({
            type: SET_ROUTE,
            data: { page: '1' }
        })
    }

    const onClickEnd = () => {
        scrollTo('#layout_list_group', -71, 'auto')
        dispatch({
            type: SET_ROUTE,
            data: { page: pageFullSize }
        })
    }

    return (
        <Style>
            {activeSize !== 1 && (
                <>
                    <ArrowButton className="button" type="button" onClick={onClickStart}>처음</ArrowButton>
                    <ArrowButton className="button" type="button" onClick={onClickPrev}>이전</ArrowButton>
                </>
            )}
            {pageSizeArr().map(v => (
                <P key={v} className={`button${v === +page ? ' active' : ''}`} type="button" num={+v} onClick={onClickPage(v)}>
                    {v}
                </P>
            ))}
            {endPage !== pageFullSize && (
                <>
                    <ArrowButton className="button" type="button" onClick={onClickNext}>다음</ArrowButton>
                    <ArrowButton className="button" type="button" onClick={onClickEnd}>끝</ArrowButton>
                </>
            )}
        </Style>
    )
}

const Style = styled.div`
    display: flex;
    justify-content: center;
    height: 28px;
    margin: 50px 0;
`
const ArrowButton = styled.button`
    &.button {
        margin: 0 2.5px;
        border: 1px solid #d3d3d3;
        padding: 0 10px;
        font-size: 13px;
        background: #f7f7f7;

        &:hover {
            border-color: #418ded
        }
    }
`
const P = styled.button`
    &.button {
        width: ${props => props.num < 100 ? '28px' : 'auto'};
        margin: 0 2.5px;
        border: 1px solid transparent;
        font-size: 14px;
        color: #666;
        font-weight: bold;
        padding: ${props => props.num < 100 ? '0' : '0 5px'};

        &:hover {
            border-color: #418ded
        }
        &.active {
            background: #418ded;
            border-color: transparent;
            color: #fff;
        }
    }
`

export default Page



// WEBPACK FOOTER //
// ./src/estimate_list/components/list/page.js